// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BceuR","title":"styles_title__65dPB"};